
import AddSeller from "../pages/seller/addSeller";
import EditSeller from "../pages/seller/editSeller";
import SellerIndex from "../pages/seller/seller";

const sellerRoutes = [
  {
    path: "seller",
    element: <SellerIndex />,
  },
  {
    path: "seller/add",
    element: <AddSeller />,
  },
  {
    path: "seller/edit/:id",
    element: <EditSeller />,
  },
];

export default sellerRoutes;